<template>
  <!-- CONTAINER DE CARD SIMPLES PARA CUSTOMIZAR - toolbar - content - actions -->
  <v-container fluid pa-5>
    <v-row justify="center">
      <v-col cols="12" xs="12" sm="7" md="5" lg="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title></v-toolbar-title>
            <v-spacer />
          </v-toolbar>

          <v-card-text>
            <!-- Slot para template de form - contents -->
            <slot name="form"></slot>
          </v-card-text>

          <!-- <v-card-actions> -->

          <!-- Slot para template de controls-->
          <v-col cols="12">
            <slot name="control"></slot>
          </v-col>

          <!-- </v-card-actions> -->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  props: ["title"]
};
</script>
